import Vue from 'vue'
import Router from 'vue-router'
import Home from './home'
import org from '../config/organization'
import mobile from "../common/mobile-input"

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
      ...Home,
    {
      path: '/record-playback/:id',
      name: 'record-playback',
      component: () => import('../views/record-playback.vue')
    },
    // AI 回放分享链接:uuid 不可猜,免登录;设了观看密码的,页面内要求输入密码。
    // 与站内入口共用同一个组件,组件按路由参数切换取数方式。
    {
      path: '/rp/:uuid',
      name: 'playback-share',
      meta: {public: true},
      component: () => import('../views/record-playback.vue')
    },
    // 开放接口签发的临时回放链接:凭 1 小时令牌访问,不需要登录。
    // 与上面按 record_id 的内部入口共用同一个组件,组件按路由参数自行切换取数方式。
    // meta.public 必须为 true——对接方会把链接转给在 MMS 中没有账号的最终用户。
    // 以下两个公开入口依赖开放接口后端(TempLinkController / 接口文档),只对有该后端的学校注册
    ...(org.show_open_api ? [{
      path: '/playback/:token',
      name: 'playback-token',
      meta: {public: true},
      component: () => import('../views/record-playback.vue')
    }, {
      path: '/open-api-doc',
      name: 'open-api-doc',
      meta:{public:true},
      component: () => import('../views/open-api-doc.vue')
    }] : []),
    // 韬视登录页底部「使用指南」入口：公开展示后台上传的用户手册。
    // 只给 tsied 注册，其他学校的产物里不会多出这个 chunk。
    ...(org.org === 'tsied' ? [{
      path: '/guide',
      name: 'guide',
      meta:{public:true},
      component: () => import(/* webpackChunkName: "about" */ '../views/guide-tsi.vue')
    }] : []),
    {
      path: '/sign-in',
      name: 'sign-in',
      meta:{public:true},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // 只有将写成这样才能够识别出来，否则报module没有发现
      component: () => import(/* webpackChunkName: "about" */  '../views/' + mobile()+ org.logon_template )
      //component:SignIn
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta:{public:true},
      component: () => import(/* webpackChunkName: "host" */ '../views/privacy.vue')
    },
    {
      path: '/host',
      name: 'host',
      meta:{public:true},
      component: () => import(/* webpackChunkName: "host" */ '../views/'+ mobile()+'host.vue')
    },
    {
      path: '/sso/login',
      name: 'sso-login',
      redirect: '/sign-in',
      props:true,
    },
    {
      path:'*',
      name:'default',
      redirect:'/',
    }
  ]
})

